<template>
  <app-page class="lo-page" fill lean>
    <!-- Kopf und Werkzeugleiste wie Verkäufe (Kundenwunsch 13.10.2026 „titel etc nach unserem design anpassen“):
         leichter Titel, Feldknöpfe für Linie und Fahrt statt Vuetify-Feldern; „Fahrt“ erst mit gewählter Linie -->
    <template #toolbar>
      <app-select
        class="lo-field"
        :value="selectedLine ? selectedLine.line_id : null"
        :items="lineItems"
        prefix="Linie"
        placeholder="bitte wählen"
        :menu-width="320"
        @input="selectLine"
      />
      <app-select
        class="lo-field"
        :value="selectedTrip ? selectedTrip.trip_id : null"
        :items="tripItems"
        prefix="Fahrt"
        placeholder="bitte wählen"
        :menu-width="360"
        :disabled="!selectedLine"
        @input="selectTrip"
      />
    </template>

    <v-progress-linear indeterminate color="primary" v-if="loading"></v-progress-linear>

    <!-- Karte und Seitenliste (300) in einer Flex-Zeile -->
    <div class="map-content">
      <div id="map" ref="mapContainer" class="map-canvas"></div>

      <app-panel
        class="map-side"
        icon="route"
        title="Fahrtverlauf"
        flush
        :state="timetables.length === 0 ? 'empty' : null"
        state-icon="route"
        state-title="Keine Fahrt ausgewählt"
        state-text="Linie und Fahrt auswählen."
      >
        <ul v-if="timetables.length > 0" class="map-stops">
          <li v-for="(timetable, i) in timetables" :key="i">
            <button
              type="button"
              class="map-stop"
              data-flush
              @click="focusTimetable(timetable)"
            >
              <span class="map-stop__time">{{ timetable.start.substr(0,5) }}</span>
              <span class="map-stop__name">{{ timetable.name }}</span>
              <span
                v-if="!(timetable.gps_latitude_to && timetable.gps_longitude_to)"
                class="map-stop__hint"
              >ohne Position</span>
            </button>
          </li>
        </ul>
      </app-panel>
    </div>
  </app-page>
</template>



<script>
import L from "leaflet";
import { latLng } from "leaflet";
import { Icon } from "leaflet";
import "leaflet-routing-machine";
import "leaflet-easybutton";
import "leaflet-easybutton/src/easy-button.css";

import axios from "axios";

delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png")
});

export default {
  computed: {
    touch() {
      return !!(this.$dichte && this.$dichte.touch);
    },
    lineItems() {
      return this.lines.map(line => ({ value: line.line_id, text: `${line.line_id} ${line.description}` }));
    },
    tripItems() {
      return this.trips.map(trip => ({ value: trip.trip_id, text: `${trip.start.substr(0, 5)} ${trip.trip_id} ${trip.description}` }));
    }
  },
  data() {
    return {
      expanded: true,
      zoomlevel: 17,
      lines: [],
      trips: [],
      timetables: [],
      selectedLine: null,
      selectedTrip: null,
      markersLayer: null,
      routingLayer: null,
      locationLayer: null,
      map: null,
      bounds: null,
      showLocations: false,
      showLocationsZoom: false,
      loading: false
    };
  },
  watch: {
    selectedLine() {
      this.readTrips();
    },
    selectedTrip() {
      this.readTimetables();
      //this.expanded = false;
    },
    timetables() {
      this.renderMarkers();
      this.renderRoute();
    },
    showLocations(show) {
      if (show && this.showLocationsZoom) {
        this.locationLayer && this.map.addLayer(this.locationLayer);
        this.renderGlobalLocations();
      } else {
        this.locationLayer && this.map.removeLayer(this.locationLayer);
      }
    },
    showLocationsZoom(show) {
      if (show && this.showLocations) {
        this.locationLayer && this.map.addLayer(this.locationLayer);
      } else {
        this.locationLayer && this.map.removeLayer(this.locationLayer);
      }
    },
    touch() {
      this.$nextTick(this.invalidateMapSize);
    }
  },
  methods: {
    selectLine(lineId) {
      this.selectedLine = this.lines.find(line => line.line_id === lineId) || null;
    },
    selectTrip(tripId) {
      this.selectedTrip = this.trips.find(trip => trip.trip_id === tripId) || null;
    },
    // Karte nach jeder Größenänderung des Containers neu vermessen (Seitenleiste ein-/ausklappen, Dichte, Fenster)
    observeMapSize() {
      if (typeof window.ResizeObserver === "undefined" || !this.$refs.mapContainer) {
        return;
      }
      this.mapResizeObserver = new window.ResizeObserver(this.invalidateMapSize);
      this.mapResizeObserver.observe(this.$refs.mapContainer);
    },
    unobserveMapSize() {
      if (this.mapResizeObserver) {
        this.mapResizeObserver.disconnect();
        this.mapResizeObserver = null;
      }
    },
    invalidateMapSize() {
      if (this.map) {
        this.map.invalidateSize();
      }
    },
    initMap() {
      const map = L.map("map").setView([48.9853399, 12.9804694], 8);
      L.tileLayer("http://{s}.tile.osm.org/{z}/{x}/{y}.png", {
        attribution:
          'Map data  &copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        maxNativeZoom: 19,
        maxZoom: 24
      }).addTo(map);
      this.map = map;

      map.on("moveend", this.renderGlobalLocations);
      this.renderGlobalLocations();

      L.easyButton(
        '<i aria-hidden="true" class="v-icon  mdi mdi-crop-free "></i>',
        this.fitBounds
      ).addTo(map);
    },
    async renderGlobalLocations() {
      const zoom = this.map.getZoom();
      //console.log(zoom);
      if (zoom >= 12) {
        this.showLocationsZoom = true;
      } else {
        this.showLocationsZoom = false;
      }

      if (this.showLocations) {
        const bounds = this.map.getBounds();
        const polygon = `(${bounds.getWest()} ${bounds.getSouth()}, ${bounds.getWest()} ${bounds.getNorth()}, ${bounds.getEast()} ${bounds.getNorth()}, ${bounds.getEast()} ${bounds.getSouth()}, ${bounds.getWest()} ${bounds.getSouth()})`;
        this.loading = true;
        const response = await axios.get(
          `${this.$store.state.baseUrl}globallocation?polygon=${polygon}`
        );
        this.loading = false;
        const locations = response.data;

        if (!this.locationLayer) {
          this.locationLayer = L.layerGroup().addTo(this.map);
        } else {
          this.locationLayer.clearLayers();
        }

        const markers = [];
        locations.forEach(location => {
          const marker = L.marker([location.latitude, location.longitude], {
            icon: new L.DivIcon({
              className: "leaflet-icon-container",
              html: `<div class='leaflet-location' ${
                this.detailLine != null ? 'style="opacity: 0.3";' : ""
              }><div class='center-abs'>H</div></div>`,
              iconSize: [50, 50]
            }),
            zIndexOffset: 1000
          });
          markers.push(marker);
          marker.bindPopup(
            `<div>
           ${location.display_name} (${location.location_id}:${location.stop})<br>
           </div>`
          );
        });

        L.layerGroup(markers).addTo(this.locationLayer);
      }
    },
    async readLines() {
      const response = await axios.get(
        `${this.$store.state.baseUrl}line?customer_id=${this.$store.state.customerId}`
      );
      this.lines = response.data;
    },
    async readTrips() {
      const response = await axios.get(
        `${this.$store.state.baseUrl}trip?customer_id=${this.$store.state.customerId}&line_id=${this.selectedLine.line_id}`
      );
      this.trips = response.data;
    },
    async readTimetables() {
      const response = await axios.get(
        `${this.$store.state.baseUrl}timetable?customer_id=${this.$store.state.customerId}&trip_id=${this.selectedTrip.trip_id}`
      );
      this.timetables = response.data;
    },
    renderMarkers() {
      if (!this.markersLayer) {
        this.markersLayer = L.layerGroup().addTo(this.map);
      } else {
        this.markersLayer.clearLayers();
      }

      const markers = [];

      this.timetables
        .filter(
          timetable => timetable.gps_latitude_to && timetable.gps_longitude_to
        )
        .forEach(timetable => {
          const marker = L.marker(
            [timetable.gps_latitude_to, timetable.gps_longitude_to],
            {
              icon: new L.DivIcon({
                className: "leaflet-icon-container",
                html: `<div class="leaflet-icon"><div class='center-abs'>${timetable.start.substr(
                  0,
                  5
                )}</div></div>`,
                iconSize: [50, 50]
              })
            }
          );
          marker.bindTooltip(
            `<div>
           Start: ${timetable.start.substr(0, 5)}<br>
           Ort: ${timetable.name} (${timetable.location_id})<br>
           Wabe: ${timetable.comb_id} <br>
           </div>`
          );
          markers.push(marker);
        });

      L.layerGroup(markers).addTo(this.markersLayer);
      this.bounds = L.featureGroup(markers).getBounds();
      this.map.fitBounds(this.bounds, {
        padding: [50, 50]
      });
    },
    renderRoute() {
      if (!this.routingLayer) {
        this.routingLayer = L.layerGroup().addTo(this.map);
      } else {
        this.routingLayer.clearLayers();
      }

      const polyline = L.polyline(
        this.timetables
          .filter(
            timetable => timetable.gps_latitude_to && timetable.gps_longitude_to
          )
          .map(timetable =>
            latLng(timetable.gps_latitude_to, timetable.gps_longitude_to)
          ),
        {
          className: "map-route"
        }
      );

      polyline.addTo(this.routingLayer);
    },
    focusTimetable(timetable) {
      this.map.flyTo(
        [timetable.gps_latitude_to, timetable.gps_longitude_to],
        this.zoomlevel
      );
    },
    fitBounds() {
      if (this.bounds && this.bounds.isValid()) {
        this.map.fitBounds(this.bounds, {
          padding: [50, 50]
        });
      }
    }
  },
  mounted() {
    this.initMap();
    this.readLines();
    this.observeMapSize();
  },
  destroyed() {
    this.unobserveMapSize();
  }
};
</script>

<style scoped>
@import "../../../node_modules/leaflet/dist/leaflet.css";

/* Ensure dropdowns appear above map */
::v-deep .v-menu__content {
  z-index: 1000 !important;
}

/* Linie und Fahrt: lange Namen kürzt der Feldknopf mit Ellipse */
.lo-field {
  max-width: 360px;
}

/* Karte und Seitenliste füllen das Blatt (AppPage fill); die Seitenliste steht wie ein Detailbereich rechts */
.map-content {
  flex: 1 1 0;
  min-height: 0;
  display: flex;
}
.map-canvas {
  flex: 1 1 0;
  min-width: 0;
  min-height: 0;
  background: var(--map-bg);
}
#map {
  z-index: 1 !important;
}
/* Kartenknöpfe wie Icon-Knöpfe: weiß mit weicher Kante, Radius 6; auf hellen Kacheln etwas kräftigerer Schatten */
.map-canvas ::v-deep .leaflet-bar {
  border: 1px solid var(--edge);
  border-radius: var(--r-ctl);
  box-shadow: var(--sh-map);
}
.map-canvas ::v-deep .leaflet-bar a,
.map-canvas ::v-deep .leaflet-bar button {
  color: var(--ink-2);
  border-bottom-color: var(--edge-soft);
}
/* Touch: Kartenknöpfe (Zoom und easyButton) 44 × 44, auch wenn Leaflet selbst kein Touch erkennt (Bedienung „Touch“) */
html.dichte-touch .map-canvas ::v-deep .leaflet-bar a,
html.dichte-touch .map-canvas ::v-deep .leaflet-bar button {
  width: 44px;
  height: 44px;
  line-height: 44px;
}
.map-side {
  flex: 0 0 300px;
  min-height: 0;
  border-width: 0 0 0 1px;
  border-radius: 0;
}
.map-side ::v-deep .app-panel__body {
  min-height: 0;
  overflow-y: auto;
}
.map-stops {
  list-style: none;
  margin: 0;
  padding: 4px 0;
}
.map-stop {
  width: 100%;
  min-height: var(--h-menu);
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 16px;
  border: 0;
  background: transparent;
  font: inherit;
  font-size: var(--fs-menu);
  line-height: var(--lh-menu);
  color: var(--ink);
  text-align: left;
  cursor: pointer;
}
:where(html:not(.dichte-touch)) .map-stop:hover {
  background: var(--hov);
}
.map-stop:active {
  background: var(--press);
}
.map-stop__time {
  flex: none;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
}
.map-stop__name {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.map-stop__hint {
  flex: none;
  font-size: 12px;
  line-height: 16px;
  color: var(--ink-3);
}
/* Schmale Fenster: Seitenliste unter der Karte */
@media (max-width: 899.98px) {
  .map-content {
    flex-direction: column;
  }
  .map-side {
    flex: 0 0 40%;
    border-width: 1px 0 0;
  }
}
/* Handy: AppPage fill wirkt nicht (natürliche Höhe) – Karte mit fester Höhe, Liste darunter */
@media (max-width: 599.98px) {
  .map-content {
    flex: none;
  }
  .map-canvas {
    flex: none;
    height: 60vh;
    min-height: 280px;
  }
  .map-side {
    flex: none;
  }
}
/* Routenlinie in Navy (Daten) statt Orange */
::v-deep .map-route {
  stroke: var(--d-foc);
}
.leaflet-shadow-pane > .leaflet-marker-shadow {
  display: none;
}
::v-deep .leaflet-icon {
  background-color: #FFFFFF !important;
  line-height: 100%;
  height: 80%;
  width: 80%;
  position: absolute;
  color: #333333 !important;
  padding: 0;
  font-weight: bold;
  font-size: 11px;
  border-radius: 50% !important;
  border: thin solid rgba(0, 0, 0, 0.12);
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .leaflet-icon-small-line {
  background-color: #FFFFFF !important;
  line-height: 100%;
  height: 30%;
  width: 80%;
  position: absolute;
  color: #333333 !important;
  padding: 0;
  font-weight: bold;
  font-size: 11px;
  border-radius: 50% !important;
  border: thin solid rgba(0, 0, 0, 0.12);
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .leaflet-icon-container {
}

::v-deep .center-abs {
  text-align: center;
}
.leaflet-routing-container {
  display: none !important;
}
</style>
